import { FintracFormSection } from 'app/modules/fintracStr/models';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

export const FINTRAC_STR_ACTION_TAKEN_TAB_SECTION: FintracFormSection = {
  type: 'tabSection',
  repeatable: false,
  label: 'Action Taken',
  name: 'actionTaken',
  fields: [
    {
      type: U21FormFieldTypes.TEXTAREA,
      name: 'description',
      label: 'Description',
      mustExistInPayload: false,
      mustHaveValueIfExist: false,
    },
  ],
  mustExistInPayload: false,
  mustHaveValueIfExist: false,
};
